// extracted by mini-css-extract-plugin
export default {"container":"tE-z","innerContainer":"uE-z","multipleLines":"vE-z","heading":"wE-z","content":"xE-z","linkColor":"yE-z"};